import React from 'react';
import { CheckCircleIcon, ArrowRightIcon, GiftIcon, AwardIcon } from 'lucide-react';
const kpis = [{
  label: 'Loans Closed MTD',
  value: '47',
  change: '+12%',
  color: '#2B8DC4'
}, {
  label: 'Pipeline Value',
  value: '$8.4M',
  change: '+5.2%',
  color: '#1E6FA0'
}, {
  label: 'Team Members',
  value: '124',
  change: '+3 new',
  color: '#2B8DC4'
}, {
  label: 'Avg. Close Time',
  value: '28d',
  change: '-2 days',
  color: '#1E6FA0'
}];
const messages = [{
  title: 'New TRID Disclosure Requirements — Effective March 15',
  body: 'All loan officers must complete the 30-minute compliance training module by March 10.',
  author: 'Jennifer Walsh · Chief Compliance Officer',
  date: 'Mar 1',
  tag: 'URGENT',
  tagColor: '#EF4444',
  tagBg: '#FEF2F2'
}, {
  title: '🎉 Swift Hits $1 Billion in Annual Volume!',
  body: "We've officially crossed the $1B milestone — top 5% of independent mortgage companies nationally.",
  author: 'Robert Swift · CEO & Founder',
  date: 'Feb 28',
  tag: 'MILESTONE',
  tagColor: '#D97706',
  tagBg: '#FFFBEB'
}, {
  title: 'Updated Rate Sheets Now Live',
  body: 'New sheets for conventional, FHA, VA, and USDA products are in the Mortgage Tools section.',
  author: 'Mark Chen · Secondary Markets',
  date: 'Mar 1',
  tag: 'RATES',
  tagColor: '#1E6FA0',
  tagBg: '#EBF5FB'
}];
const celebrations = [{
  name: 'Sarah Kim',
  event: 'Birthday',
  date: 'Mar 8',
  icon: GiftIcon,
  color: '#2B8DC4'
}, {
  name: 'Marcus Thompson',
  event: '3 Year Anniversary',
  date: 'Mar 12',
  icon: AwardIcon,
  color: '#1A2B3C'
}, {
  name: 'Priya Rajan',
  event: 'Birthday',
  date: 'Mar 15',
  icon: GiftIcon,
  color: '#2B8DC4'
}, {
  name: 'Derek Liu',
  event: '5 Year Anniversary',
  date: 'Mar 20',
  icon: AwardIcon,
  color: '#1A2B3C'
}];
const upcomingEvents = [{
  title: 'All-Hands Meeting',
  date: 'Mar 5',
  time: '10:00 AM'
}, {
  title: 'Q1 Sales Review',
  date: 'Mar 8',
  time: '2:00 PM'
}, {
  title: 'Compliance Training',
  date: 'Mar 12',
  time: '9:00 AM'
}, {
  title: 'New Product Launch',
  date: 'Mar 15',
  time: '11:00 AM'
}];
const myTasks = [{
  task: 'Review loan application #4821',
  due: 'Today',
  done: false
}, {
  task: 'Complete NMLS renewal',
  due: 'Mar 7',
  done: false
}, {
  task: 'Submit Q1 pipeline report',
  due: 'Mar 10',
  done: true
}, {
  task: 'Team 1:1 with Sarah K.',
  due: 'Mar 6',
  done: false
}];
const newBirds = [{
  name: 'Rachel Torres',
  title: 'Loan Originator',
  dept: 'Sales',
  avatar: 'RT',
  color: '#2B8DC4',
  startDate: 'Mar 3',
  location: 'Phoenix, AZ',
  funFact: 'Speaks 3 languages fluently'
}, {
  name: 'Kevin Patel',
  title: 'Junior Processor',
  dept: 'Operations',
  avatar: 'KP',
  color: '#1A2B3C',
  startDate: 'Mar 1',
  location: 'Dallas, TX',
  funFact: 'Former college basketball player'
}, {
  name: 'Mia Johnson',
  title: 'Marketing Coordinator',
  dept: 'Marketing',
  avatar: 'MJ',
  color: '#1E6FA0',
  startDate: 'Feb 28',
  location: 'Remote',
  funFact: 'Has visited 22 countries'
}];
export function Dashboard() {
  return <div style={{
    maxWidth: 800,
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 28
  }} data-id="element-102">
      {/* Greeting Card */}
      <div style={{
      background: '#FFFFFF',
      borderRadius: 16,
      border: '1px solid #E8ECF2',
      padding: 32,
      boxShadow: '0 1px 3px rgba(0,0,0,0.04)'
    }} data-id="element-103">
        <h1 style={{
        fontSize: 28,
        fontWeight: 800,
        color: '#1A2B3C',
        margin: '0 0 8px'
      }} data-id="element-104">
          Good morning, Jamie
        </h1>
        <p style={{
        fontSize: 14,
        color: '#8896AB',
        margin: '0 0 20px'
      }} data-id="element-105">
          Monday, March 3, 2025
        </p>
        <div style={{
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap'
      }} data-id="element-106">
          <span style={{
          background: '#F5F7FA',
          border: '1px solid #E8ECF2',
          borderRadius: 20,
          padding: '6px 16px',
          fontSize: 13,
          color: '#5A6A8A'
        }} data-id="element-107">
            🏆 Top Originator — February
          </span>
          <span style={{
          background: '#F5F7FA',
          border: '1px solid #E8ECF2',
          borderRadius: 20,
          padding: '6px 16px',
          fontSize: 13,
          color: '#5A6A8A'
        }} data-id="element-108">
            47 loans closed MTD
          </span>
        </div>
      </div>

      {/* KPI Row */}
      <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      gap: 16
    }} data-id="element-109">
        {kpis.map(kpi => <div key={kpi.label} style={{
        background: '#FFFFFF',
        borderRadius: 16,
        border: '1px solid #E8ECF2',
        padding: 24,
        boxShadow: '0 1px 3px rgba(0,0,0,0.04)'
      }} data-id="element-110">
            <div style={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          background: kpi.color,
          marginBottom: 12
        }} data-id="element-111" />
            <div style={{
          fontSize: 32,
          fontWeight: 800,
          color: '#1A2B3C',
          marginBottom: 4
        }} data-id="element-112">
              {kpi.value}
            </div>
            <div style={{
          fontSize: 13,
          color: '#8896AB'
        }} data-id="element-113">
              {kpi.label}
            </div>
          </div>)}
      </div>

      {/* CEO Message */}
      <div style={{
      background: '#FFFFFF',
      borderRadius: 16,
      border: '1px solid #E8ECF2',
      padding: 24,
      boxShadow: '0 1px 3px rgba(0,0,0,0.04)'
    }} data-id="element-114">
        <h2 style={{
        fontSize: 18,
        fontWeight: 700,
        color: '#1A2B3C',
        margin: '0 0 16px'
      }} data-id="element-115">
          From the CEO
        </h2>
        <hr style={{
        border: 'none',
        borderTop: '1px solid #E8ECF2',
        margin: '0 0 20px'
      }} data-id="element-116" />
        <div style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 16
      }} data-id="element-117">
          <div style={{
          width: 48,
          height: 48,
          borderRadius: 12,
          background: 'linear-gradient(135deg, #1A2B3C, #0D1B2A)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 16,
          fontWeight: 900,
          color: 'white',
          transform: 'skewX(-4deg)',
          flexShrink: 0
        }} data-id="element-118">
            JW
          </div>
          <div data-id="element-119">
            <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            marginBottom: 4
          }} data-id="element-120">
              <span style={{
              fontSize: 14,
              fontWeight: 700,
              color: '#1A2B3C'
            }} data-id="element-121">
                Jennifer Walsh
              </span>
              <span style={{
              fontSize: 12,
              color: '#5A6A8A'
            }} data-id="element-122">
                CEO & Founder
              </span>
              <span style={{
              fontSize: 11,
              color: '#8896AB',
              marginLeft: 'auto'
            }} data-id="element-123">
                Mar 1, 2025
              </span>
            </div>
            <h3 style={{
            fontSize: 16,
            fontWeight: 700,
            color: '#1A2B3C',
            margin: '0 0 8px'
          }} data-id="element-124">
              Q1 2025: Building Momentum
            </h3>
            <p style={{
            fontSize: 13,
            color: '#5A6A8A',
            lineHeight: 1.6,
            margin: '0 0 12px'
          }} data-id="element-125">
              Team, I'm incredibly proud of what we've accomplished. We crossed
              $1B in annual volume and our client satisfaction scores are at an
              all-time high. Let's keep this momentum going into Q1...
            </p>
            <button style={{
            fontSize: 13,
            fontWeight: 700,
            color: '#2B8DC4',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            padding: 0
          }} data-id="element-126">
              Read Full Message <ArrowRightIcon size={14} data-id="element-127" />
            </button>
          </div>
        </div>
      </div>

      {/* Message Board */}
      <div style={{
      background: '#FFFFFF',
      borderRadius: 16,
      border: '1px solid #E8ECF2',
      padding: 24,
      boxShadow: '0 1px 3px rgba(0,0,0,0.04)'
    }} data-id="element-128">
        <h2 style={{
        fontSize: 18,
        fontWeight: 700,
        color: '#1A2B3C',
        margin: '0 0 16px'
      }} data-id="element-129">
          Message Board
        </h2>
        <hr style={{
        border: 'none',
        borderTop: '1px solid #E8ECF2',
        margin: '0 0 20px'
      }} data-id="element-130" />
        <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 20
      }} data-id="element-131">
          {messages.map((msg, i) => <div key={i} style={{
          paddingBottom: i !== messages.length - 1 ? 20 : 0,
          borderBottom: i !== messages.length - 1 ? '1px solid #E8ECF2' : 'none'
        }} data-id="element-132">
              <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            marginBottom: 8
          }} data-id="element-133">
                <span style={{
              fontSize: 10,
              fontWeight: 700,
              padding: '2px 8px',
              borderRadius: 4,
              background: msg.tagBg,
              color: msg.tagColor,
              letterSpacing: '0.04em'
            }} data-id="element-134">
                  {msg.tag}
                </span>
                <span style={{
              fontSize: 11,
              color: '#8896AB'
            }} data-id="element-135">
                  {msg.date}
                </span>
              </div>
              <div style={{
            fontSize: 14,
            fontWeight: 700,
            color: '#1A2B3C',
            marginBottom: 6,
            lineHeight: 1.4
          }} data-id="element-136">
                {msg.title}
              </div>
              <div style={{
            fontSize: 13,
            color: '#5A6A8A',
            lineHeight: 1.5,
            marginBottom: 8
          }} data-id="element-137">
                {msg.body}
              </div>
              <div style={{
            fontSize: 12,
            color: '#8896AB',
            fontWeight: 500
          }} data-id="element-138">
                {msg.author}
              </div>
            </div>)}
        </div>
      </div>

      {/* New Birds */}
      <div style={{
      background: '#FFFFFF',
      borderRadius: 16,
      border: '1px solid #E8ECF2',
      padding: '24px 24px 16px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.04)'
    }} data-id="element-139">
        <h2 style={{
        fontSize: 18,
        fontWeight: 700,
        color: '#1A2B3C',
        margin: '0 0 16px'
      }} data-id="element-140">
          New Birds of the Week 🐦
        </h2>
        <hr style={{
        border: 'none',
        borderTop: '1px solid #E8ECF2',
        margin: '0 0 20px'
      }} data-id="element-141" />
        <div style={{
        display: 'flex',
        overflowX: 'auto',
        gap: 16,
        paddingBottom: 8
      }} data-id="element-142">
          {newBirds.map((bird, i) => <div key={i} style={{
          minWidth: 200,
          background: '#FFFFFF',
          borderRadius: 16,
          border: '1px solid #E8ECF2',
          padding: 20,
          display: 'flex',
          flexDirection: 'column',
          gap: 12
        }} data-id="element-143">
              <div style={{
            width: 36,
            height: 36,
            borderRadius: 10,
            background: bird.color,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 12,
            fontWeight: 900,
            color: 'white',
            transform: 'skewX(-4deg)',
            flexShrink: 0
          }} data-id="element-144">
                {bird.avatar}
              </div>
              <div data-id="element-145">
                <div style={{
              fontSize: 14,
              fontWeight: 700,
              color: '#1A2B3C',
              marginBottom: 2
            }} data-id="element-146">
                  {bird.name}
                </div>
                <div style={{
              fontSize: 12,
              color: '#5A6A8A',
              marginBottom: 8
            }} data-id="element-147">
                  {bird.title}
                </div>
                <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              flexWrap: 'wrap'
            }} data-id="element-148">
                  <span style={{
                fontSize: 10,
                fontWeight: 700,
                padding: '2px 6px',
                borderRadius: 4,
                background: '#F5F7FA',
                color: '#5A6A8A'
              }} data-id="element-149">
                    {bird.dept}
                  </span>
                  <span style={{
                fontSize: 11,
                color: '#8896AB'
              }} data-id="element-150">
                    Started {bird.startDate}
                  </span>
                </div>
              </div>
            </div>)}
        </div>
      </div>

      {/* Tasks and Events */}
      <div style={{
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 16
    }} data-id="element-151">
        {/* Tasks */}
        <div style={{
        background: '#FFFFFF',
        borderRadius: 16,
        border: '1px solid #E8ECF2',
        padding: 24,
        boxShadow: '0 1px 3px rgba(0,0,0,0.04)'
      }} data-id="element-152">
          <h2 style={{
          fontSize: 18,
          fontWeight: 700,
          color: '#1A2B3C',
          margin: '0 0 16px'
        }} data-id="element-153">
            My Tasks
          </h2>
          <hr style={{
          border: 'none',
          borderTop: '1px solid #E8ECF2',
          margin: '0 0 20px'
        }} data-id="element-154" />
          <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 16
        }} data-id="element-155">
            {myTasks.map((task, i) => <div key={i} style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 12
          }} data-id="element-156">
                <CheckCircleIcon size={18} color={task.done ? '#2B8DC4' : '#E8ECF2'} style={{
              flexShrink: 0,
              marginTop: 1
            }} data-id="element-157" />
                <div data-id="element-158">
                  <p style={{
                fontSize: 13,
                color: task.done ? '#8896AB' : '#1A2B3C',
                margin: '0 0 4px',
                fontWeight: 500,
                textDecoration: task.done ? 'line-through' : 'none'
              }} data-id="element-159">
                    {task.task}
                  </p>
                  <p style={{
                fontSize: 12,
                color: '#8896AB',
                margin: 0
              }} data-id="element-160">
                    Due: {task.due}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        {/* Events */}
        <div style={{
        background: '#FFFFFF',
        borderRadius: 16,
        border: '1px solid #E8ECF2',
        padding: 24,
        boxShadow: '0 1px 3px rgba(0,0,0,0.04)'
      }} data-id="element-161">
          <h2 style={{
          fontSize: 18,
          fontWeight: 700,
          color: '#1A2B3C',
          margin: '0 0 16px'
        }} data-id="element-162">
            Upcoming
          </h2>
          <hr style={{
          border: 'none',
          borderTop: '1px solid #E8ECF2',
          margin: '0 0 20px'
        }} data-id="element-163" />
          <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 16
        }} data-id="element-164">
            {upcomingEvents.map((event, i) => <div key={i} style={{
            display: 'flex',
            alignItems: 'center',
            gap: 12
          }} data-id="element-165">
                <div style={{
              minWidth: 48,
              padding: '6px 8px',
              borderRadius: 8,
              background: '#F5F7FA',
              textAlign: 'center',
              flexShrink: 0
            }} data-id="element-166">
                  <div style={{
                fontSize: 12,
                fontWeight: 700,
                color: '#5A6A8A'
              }} data-id="element-167">
                    {event.date}
                  </div>
                </div>
                <div data-id="element-168">
                  <p style={{
                fontSize: 13,
                fontWeight: 600,
                color: '#1A2B3C',
                margin: '0 0 4px'
              }} data-id="element-169">
                    {event.title}
                  </p>
                  <p style={{
                fontSize: 12,
                color: '#8896AB',
                margin: 0
              }} data-id="element-170">
                    {event.time}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>

      {/* Celebrations */}
      <div style={{
      background: '#FFFFFF',
      borderRadius: 16,
      border: '1px solid #E8ECF2',
      padding: 24,
      boxShadow: '0 1px 3px rgba(0,0,0,0.04)'
    }} data-id="element-171">
        <h2 style={{
        fontSize: 18,
        fontWeight: 700,
        color: '#1A2B3C',
        margin: '0 0 16px'
      }} data-id="element-172">
          Celebrations 🎂
        </h2>
        <hr style={{
        border: 'none',
        borderTop: '1px solid #E8ECF2',
        margin: '0 0 20px'
      }} data-id="element-173" />
        <div style={{
        display: 'flex',
        gap: 12,
        flexWrap: 'wrap'
      }} data-id="element-174">
          {celebrations.map((item, i) => {
          const Icon = item.icon;
          return <div key={i} style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: '12px 16px',
            borderRadius: 12,
            background: '#F5F7FA',
            border: '1px solid #E8ECF2'
          }} data-id="element-175">
                <div style={{
              width: 32,
              height: 32,
              borderRadius: 8,
              background: `${item.color}15`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            }} data-id="element-176">
                  <Icon size={16} color={item.color} data-id="element-177" />
                </div>
                <div data-id="element-178">
                  <div style={{
                fontSize: 13,
                fontWeight: 700,
                color: '#1A2B3C',
                marginBottom: 2
              }} data-id="element-179">
                    {item.name}
                  </div>
                  <div style={{
                fontSize: 11,
                color: '#5A6A8A'
              }} data-id="element-180">
                    {item.event} ·{' '}
                    <span style={{
                  fontWeight: 600,
                  color: '#2B8DC4'
                }} data-id="element-181">
                      {item.date}
                    </span>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </div>;
}